import { render, staticRenderFns } from "./show-all.vue?vue&type=template&id=6b5876d8&"
import script from "./show-all.vue?vue&type=script&lang=js&"
export * from "./show-all.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports